import { StateParams } from "@uirouter/angularjs";
import { IOnInit, ICompileService } from "angular";
import { RecordDataSource } from "../../../records/grids";
import { ColDef } from "../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../records/server/query";

import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../app/records/server/serverUtility";

import "angular-formly";
import {
  defaultValueGetterFactory,
  emailValueGetter,
  telephoneValueGetter,
} from "../../../records/grids/cells/valueGetters";
const gridId = Symbol("main.contracbook.grid");

export class ContactBookController implements IOnInit {
  static $inject = [
    "$stateParams",
    "slotTrakMachinesServer",
    serverUtilityName,
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    "$compile",
  ];
  readonly gridDataSource: RecordDataSource;
  readonly gridSettings: IGridSettings;
  readonly columns: ColDef[];
  readonly defaultQuery: IQuery = {};
  templateId = {};
  contactBook: any[] = [];

  constructor(
    public readonly $stateParams: StateParams,
    public readonly slotTrakMachinesServer: any,
    public readonly serverUtility: ServerUtility,
    gridSettingsService: GridSettingsService,
    columnDefinitionService: ColumnDefinitionService,
    $compile: ICompileService
  ) {
    this.gridDataSource = new RecordDataSource(
      serverUtility,
      "/api/addressBook/AddressBook"
    );

    this.gridSettings = gridSettingsService.getGridSettings(gridId);

    this.columns = [
      columnDefinitionService.getLinkColDef({
        headerName: "info",
        iconClass: "fa fa-info-circle text-primary",
        colId: "detail",
        width: 20,
        stateExpression: "main.contactBook.Info({ contactbookId: data.Id})",
      }),
      columnDefinitionService.getLinkColDef({
        headerName: "edit",
        iconClass: "fa fa-pencil text-primary",
        colId: "edit",
        stateExpression: "main.contactBook.Edit({ contactbookId: data.Id})",
      }),
      columnDefinitionService.getNumberColDef({
        field: "Id",
        header: "Id",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "Title",
        header: "Title",
      }),
      columnDefinitionService.getStringColDef({
        field: "TypeName",
        header: "Type",
      }),
      columnDefinitionService.getStringColDef({
        field: "Name",
        header: "Contact Name",
      }),
      columnDefinitionService.getStringColDef({
        field: "BusinessName",
        header: "Business Name",
      }),
      columnDefinitionService.getStringColDef({
        field: "Contact",
        header: "Phone Number",
        valueGetter: telephoneValueGetter,
        csvValueGetter: defaultValueGetterFactory(),
      }),
      columnDefinitionService.getStringColDef({
        field: "Email",
        header: "Email address",
        valueGetter: emailValueGetter,
        csvValueGetter: defaultValueGetterFactory(),
      }),
      columnDefinitionService.getStringColDef({
        field: "CellPhone",
        header: "Cell Phone",
        valueGetter: telephoneValueGetter,
        csvValueGetter: defaultValueGetterFactory(),
      }),
      columnDefinitionService.getStringColDef({
        field: "Address",
        header: "Address",
      }),
      columnDefinitionService.getStringColDef({
        field: "Notes",
        header: "Notes",
      }),
    ];
  }

  $onInit(): void {}
}
